// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "12px";
var _4 = "currency-SX15i";
var _5 = "selector-31Lnu input-1wrIg";
var _6 = "selector_disabled-1rmq7";
var _7 = "selector__inner-3pkdE";
var _8 = "selector__symbol-3746r";
var _9 = "dropdown-3Dv9E";
var _a = "item-2E9hJ";
var _b = "arrowIcon-3Z8hC";
var _c = "arrowIcon_flipped-1HuEC";
export { _1 as "__esModule", _2 as "mobile", _3 as "block_padding", _4 as "currency", _5 as "selector", _6 as "selector_disabled", _7 as "selector__inner", _8 as "selector__symbol", _9 as "dropdown", _a as "item", _b as "arrowIcon", _c as "arrowIcon_flipped" }
export default { "__esModule": _1, "mobile": _2, "block_padding": _3, "currency": _4, "selector": _5, "selector_disabled": _6, "selector__inner": _7, "selector__symbol": _8, "dropdown": _9, "item": _a, "arrowIcon": _b, "arrowIcon_flipped": _c }
